import React from 'react'

function RelatedSection() {
    return (
        <>
            <div className="self-start mt-9 text-2xl font-bold text-right whitespace-nowrap text-zinc-900">
                مقالات مشابهة
            </div>
            <div className="mt-6 max-md:max-w-full">
                <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                    <div className="flex flex-col w-6/12 ml-5 max-md:ml-0 max-md:w-full">
                        <div className="flex grow gap-1 justify-between px-2.5 py-2 w-full bg-white rounded-2xl border border-solid border-zinc-300 max-md:mt-5">
                            <div className="flex overflow-hidden relative flex-col items-start pt-5 pr-5 pb-12 pl-16 text-sm font-medium tracking-normal leading-3 text-center text-pink-800 uppercase whitespace-nowrap rounded-xl aspect-[1.22] w-[183px] max-md:pl-5">
                                <img
                                    loading="lazy"
                                    srcSet="https://s3-alpha-sig.figma.com/img/5433/806e/cf31bc2ae3940f5b05a9bd91c11a2ad2?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=AXvIRHvN-Nj1atwEdUZHythcfTmYZO0HjYbSiJ-FZqg0FpNbMgLlBp0BTcjb9v49hHbeQRWfDwjRt5VlHvM2EbWe3IR31RCDSPR7UexuozKcHDEf37EvMjTjlFgmUN~tA7sdhASSyeBKgAYY6bcHRbiP4Y3fonC9n7cXhNr7ujjMETwI3i5iquBqUytTMbLYEqfscylKgGDcm7eK1R-ojpZ38VTthz2-sAFVvIkqC8t42mf8OhwKOjazZNHl-1UD1Dlpk6JagFE13bd3JTGfs77Py3dN3nH6AOHPQ99PQKmIhu0KSCzrhTweuUUAFEKILdwEaMZxiUhiTfb-WwFjKw__"
                                    className="object-cover absolute inset-0 size-full"
                                />
                                <div className="relative justify-center px-2.5 py-1 bg-red-100 rounded-xl border-pink-800 border-solid aspect-[2.61] border-[0.5px]">
                                    صحة
                                </div>
                            </div>
                            <div className="flex flex-col flex-1 justify-center px-4 py-1.5 text-right bg-white bg-opacity-70">
                                <div className="text-lg font-bold text-zinc-900">
                                    انتشال أحياء في درنة والمساعدات الدولية تتدفق على
                                    ليبيا
                                    <br />
                                </div>
                                <div className="self-start mt-3 text-sm whitespace-nowrap text-stone-900">
                                    18 April 2023
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RelatedSection